import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import type { QuizPlayerScore } from '@mentimeter/quiz-types';
import { Box } from '@mentimeter/ragnar-ui/box';
import { CenteringContainer } from '../../shared/components/quiz/CenteringContainer';
import { RevealAnswer } from '../../shared/components/quiz/RevealAnswer';
import { TitleSection } from '../../shared/components/title-section/TitleSection';
import { Results } from './results/Results';
import type { QuizOpenPresentationProps } from './types';

interface ViewOnlyPresentationProps extends QuizOpenPresentationProps {
  results: QuizPlayerScore[] | undefined;
  CanvasVisualizationArea: InteractiveCanvasComponents['CanvasVisualizationArea'];
  shouldAnimate: boolean;
  isReadonly: boolean;
}

export const ViewOnlyPresentation = ({
  title,
  styledTitle,
  visibleCorrectAnswer,
  label,
  description,
  textSizeOffset,
  shouldAnimate,
  isReadonly,
  results,
  CanvasVisualizationArea,
}: ViewOnlyPresentationProps) => {
  const ConditionalWrapper = CanvasVisualizationArea ?? Box;

  return (
    <>
      <TitleSection
        title={title}
        styledTitle={styledTitle}
        description={description}
        label={label}
        fontSizeOffset={textSizeOffset}
        showTextSizeDropdown={true}
        hideAIEditingSuggestions
      />
      <ConditionalWrapper width="100%" flex="1">
        <CenteringContainer>
          {results !== undefined && (
            <RevealAnswer
              correctAnswer={visibleCorrectAnswer}
              enableAnimation={shouldAnimate}
            >
              <Results
                results={results}
                isReadonly={isReadonly}
                onMarkAnswer={undefined}
              />
            </RevealAnswer>
          )}
        </CenteringContainer>
      </ConditionalWrapper>
    </>
  );
};
